let $attachmentGrid = null;
let projectId = null;

export default function ($grid) {
    $attachmentGrid = $grid;
    projectId = $('[data-project-id]').data('project-id');
    if ($attachmentGrid && $attachmentGrid.length) initializeGrid();
}

const initializeGrid = () => {
    $attachmentGrid.kendoGrid({
        /*mobile: "phone",*/
        resizable: true, columns: [
            {
                field: 'fCat', title: 'Category', attributes: {class: ''}, width: 225
            }, {
                field: 'fString', title: 'File Name', attributes: {class: ''}
            }, {
                field: 'fExt', title: 'Extension', attributes: {class: ''}, width: 110
            }, {
                field: 'uploadedBy',
                title: 'Uploaded By',
                attributes: {class: ''},
                hidden: true
            }, {
                field: 'datestamp',
                title: 'Date Uploaded',
                attributes: {class: ''},
                type: 'date',
                format: '{0: M/d/yyyy}',
                width : 145
            }, {
                field: 'attID',title: 'Actions', hidden: false, menu: false, attributes: {class: 'attID'}, template: function (data) {
                    return `<span class="k-align-content-end" style=""><span><a data-uid-download="${data.uid}" class="k-button" href="/Download/Attachment?attid=${data.attID}"><span class="k-icon k-i-download"></span></a></span><span><a data-uid-remove="${data.uid}" data-file-id="${data.attID}" class="k-button l-delete js-delete-btn"><span class="k-icon k-i-delete"></span></a></span></span>`;
                }, width : 120,filterable: false
            },
            {
                field: 'attID', hidden: true, menu: false, attributes: {class: 'attID'}
            }
        ], dataSource: {
            autoSync: true, schema: {
                model: {
                    id: 'attID', fields: {
                        attID: {editable: false, type: 'int'},
                        fString: {editable: false, type: 'string'},
                        fPath: {editable: false, type: 'string'},
                        fCat: {editable: false, type: 'string'},
                        fExt: {editable: false, type: 'string'},
                        uploadedBy: {editable: false, type: 'string'},
                        datestamp: {editable: false, type: 'date'},
                        fKeywords: {editable: false},
                        fCo: {editable: false, type: 'int'},
                        fJob: {editable: false, type: 'string'}
                    }
                }
            }, transport: {
                read: {
                    url: `/Attachment/GetGridAttachments?pid=${projectId}`, type: 'GET', dataType: 'json'
                }, parameterMap: function (data, type) {
                    let rs = {};
                    if (type === 'read') {
                        return rs;
                    }
                }
            }
        }, dataBound: function (arg) {
            removeAttachment($('.js-delete-btn'));
        }, mobile: true, scrollable: true, sortable: {
            mode: 'multiple'
        }, filterable: true, editable: true, columnMenu: true
    });
}

const removeAttachment = function ($attachmentDelete) {
    $attachmentDelete.unbind('click');
    $attachmentDelete.click(function (event) {
        const ele = event.currentTarget, attId = ele.getAttribute('data-file-id');
        $.ajax({
            type: 'POST', url: '/Attachment/RemoveAttachment', data: 'attID=' + attId, success: function (attId, response) {
                if (response === 'success') {
                    $attachmentGrid.data('kendoGrid').dataSource.read();
                }
            }
        });
    });
};